const labels = {
  'new.posts.title.singular': 'Nuovo post:',
  'new.posts.title.plural': 'Nuovi post:',

  'badge.new.posts.text.singular': 'nuovo post',
  'badge.new.posts.text.plural': 'nuovi post',

  'pinnedpost.author.text': '- di ',
  'pinnedpost.readmore.label.more': 'Leggi di più',
  'pinnedpost.readmore.label.less': 'Leggi di meno',

  'time.seconds.ago': 'meno di un minuto fa',
  'time.a.minute.ago': '1 minuto fa',
  'time.minutes.ago': 'minuti fa',

  'banner-no-cookies.title': 'Non visualizzi questo contenuto?',
  'banner-no-cookies.subtitle.1': 'Siamo spiacenti! Per poter visualizzare questo contenuto',
  'banner-no-cookies.subtitle.2': ', clicca su Gestisci cookie e Accetta tutto',
  'banner-no-cookies.button.label': 'Gestisci cookie',

  'post.video.go.to.video': 'Vai al contenuto video',
  'post.link.cta.text': 'Vai al contenuto',

  'social.embed.go.to.post': 'Vai al post',
  'social.embed.twitter.label': 'X',
  'social.embed.facebook.label': 'Facebook',
  'social.embed.instagram.label': 'Instagram',
  'social.embed.youtube.label': 'Youtube',

  'adv.label': 'Pubblicità',
};

export default labels;

export type labelType = keyof typeof labels;
